import TPBTopActions from './TPBTopActions.component';

export default TPBTopActions;
